import { combineReducers, } from "@reduxjs/toolkit";
import mainBoard from "./mainBoard/ordersUXSlice";
import trades from "./trades/tradesUXSlice";
import orderBook from "./orderBook/orderBookUXSlice";
import ticker from "./ticker/tickerUXSlice";
import orderInd from "./orderIndicative/orderIndUXSlice";

const uxTradingReducer = combineReducers({
  mainBoard,
  trades,
  orderBook,
  ticker,
  orderInd,
});

export default uxTradingReducer